import { MainLayoutComponent } from '../../components/main-layout/main-layout.component'
import { Routes } from '@angular/router'
import { AuthGuard } from 'src/app/guards/auth.guard'
import { CompoundsComponent } from './compounds.component'
import { NgxPermissionsGuard } from 'ngx-permissions'
import { UpdateCompoundComponent } from './update-compound/update-compound.component'
import { CreateCompoundComponent } from './create-compound/create-compound.component'

export const compoundsRoutes: Routes = [
  {
    path: 'compounds',
    component: MainLayoutComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      permissions: {
        only: 'COMPOUNDS',
        redirectTo: '/',
      },
    },
    children: [
      { path: '', component: CompoundsComponent },
      { path: 'create', component: CreateCompoundComponent },
      { path: ':id', redirectTo: ':id/general' },
      { path: ':id/:tab', component: UpdateCompoundComponent },
    ],
  },
]
